// extracted by mini-css-extract-plugin
export const overlay = "Modal-module--overlay--WSsyO";